


















































import { Component, Prop } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import { required, requiredIf } from 'vuelidate/lib/validators';
import ContactsService from '@/service/ContactsService';
import Base from '@/views/Base';
import { Registration, RegistrationUser } from '@/models/Registration';
import { validateEmail } from '@/utils/validators';

@Component
export default class ImportItem extends Base {
  @Prop() item!: RegistrationUser;
  @Prop() phoneRequired!: boolean;
  @Prop() registration!: Registration;

  @Validations()
  get validations() {
    return {
      item: {
        lastname: { required },
        phone: {
          required: requiredIf(() => this.phoneRequired),
          noLetters: ContactsService.noLettersValidator,
          format: this.phoneValidation
        },
        email: { required, email: validateEmail },
        company: {},
        customValues: {
          $each: {
            value: {
              required: requiredIf((field: any) => {
                const customField = this.registration.customFields.find((f) => f.id === field.fieldId);
                return customField?.required;
              })
            }
          }
        }
      }
    };
  }

  mounted(): void {
    this.$v.item.$touch();
  }

  focus(): void {
    this.$v.item.phone?.$reset();
  }

  submit(): void {
    if (!this.$v.item.$invalid) {
      this.item.valid = true;
      this.$emit('submit');
    }
  }

  phoneValidation(): Promise<boolean> | boolean {
    const phone = this.$v.item.phone;
    if (phone?.$dirty && this.item.phone) {
      return ContactsService.validatePhoneNumbers([this.item.phone])
        .then((validatedNumbers) => {
          const validNumber = validatedNumbers[0];
          const phoneIsValid = validNumber.validNumber;
          if (phoneIsValid) {
            this.item.phone = validNumber.international;
          }
          return phoneIsValid;
        })
        .catch((err) => {
          this.showNetworkError(err);
          return false;
        });
    }
    return true;
  }

  validateState(val: string): boolean | null {
    const validate: any = this.$v.item[val];
    return validate.$dirty ? !validate.$error : null;
  }
}
